const AFTER_PAY_MIN_MONTHLY_LOAN = 400;

export function isBasketEligibleForMonthlyLoan(
    orderTotal?: number,
    payByMonthEnabled?: boolean,
): boolean {
    const isPayByMonthEnabled = payByMonthEnabled === true;
    const isOrderTotalEligible = (orderTotal ?? 0) > AFTER_PAY_MIN_MONTHLY_LOAN;
    return isPayByMonthEnabled && isOrderTotalEligible;
}
